import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const StyledHeroSection = styled.section`
  min-height: 92vh;
  display: flex;
  align-items: center;
  padding: 0;
  position: relative;

  .inner {
    width: 100%;
    max-width: 1260px;
    margin: 0 auto;
    padding: 0 clamp(28px, 6vw, 80px);
  }

  .frame {
    max-width: 1020px;
    padding: clamp(36px, 4vw, 56px) 0;
  }

  .eyebrow {
    margin: 0 0 26px 0;
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 13px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  .headline {
    margin: 0;
    color: var(--text-primary);
    font-size: clamp(52px, 8vw, 108px);
    line-height: 0.96;
    letter-spacing: -0.055em;
    max-width: 980px;
    font-weight: 600;
  }

  .headline .accent {
    color: var(--sydneyblue);
  }

  .subheadline {
    margin: 30px 0 0;
    max-width: 760px;
    color: var(--text-secondary);
    font-size: clamp(19px, 2vw, 24px);
    line-height: 1.75;
  }

  .subheadline strong {
    color: var(--text-primary);
    font-weight: 600;
  }

  .capabilityLine {
    margin: 28px 0 0;
    max-width: 860px;
    color: var(--text-muted);
    font-size: 14px;
    line-height: 1.9;
    font-family: var(--font-mono);
  }

  .capabilityLine strong {
    color: var(--text-secondary);
    font-weight: 500;
  }

  .ctaRow {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-top: 38px;
  }

  .primaryBtn,
  .secondaryBtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 52px;
    padding: 0 24px;
    border-radius: 999px;
    text-decoration: none;
    font-size: 13px;
    font-family: var(--font-mono);
    transition: var(--transition);
  }

  .primaryBtn {
    color: #ffffff;
    background: #111111;
    border: 1px solid #111111;
  }

  .primaryBtn:hover {
    background: #2a2a2a;
    border-color: #2a2a2a;
    color: #ffffff;
    transform: translateY(-1px);
  }

  .secondaryBtn {
    color: var(--text-primary);
    background: rgba(255, 255, 255, 0.42);
    border: 1px solid var(--border-light);
    backdrop-filter: blur(10px);
  }

  .secondaryBtn:hover {
    color: var(--text-primary);
    border-color: var(--border-medium);
    background: rgba(255, 255, 255, 0.68);
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    min-height: auto;
    padding: calc(var(--nav-height) + 16px) 0 90px;

    .subheadline {
      max-width: 100%;
    }
  }
`;

const Hero = () => {
  return (
    <StyledHeroSection>
      <div className="inner">
        <div className="frame">
          <p className="eyebrow">
            Software • Data • Pipelines • Machine Learning • AI
          </p>

          <h1 className="headline">
            Building <span className="accent">software, pipelines,</span> and
            intelligent systems from messy real-world data.
          </h1>

          <p className="subheadline">
            I’m <strong>Hemang Sharma</strong>, a builder working across
            <strong> analytics, software engineering, data pipelines, machine learning, and AI</strong>,
            designing systems that turn complexity into reliable and measurable outcomes.
          </p>

          <p className="capabilityLine">
            From <strong>production analytics and workflow automation</strong> to
            <strong> forecasting, OCR, NLP, dashboards, geospatial systems, and machine learning</strong>,
            I build technical systems that are useful, defensible, and deployable.
          </p>

          <div className="ctaRow">
            <Link className="primaryBtn" to="/projects">
              Explore Work
            </Link>
            <Link className="secondaryBtn" to="/experience">
              View Experience
            </Link>
          </div>
        </div>
      </div>
    </StyledHeroSection>
  );
};

export default Hero;